// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3m2g1","comment":"styles_comment__2dcRx"};